export const BI_CONSTS = {
    GROUP: {
        IMPRESSIONS: 'user_impression',
        ACTION: 'user_action',
    },
};
